import { api } from "@services/baseURL";

export const SaveFormulario = async (data) => {
  try {
    const response = await api.post(`Formulario`, data);

    return response.data;
  } catch (error) {
    console.error("Erro ao salvar formulário", error);
    throw error;
  }
};

export const SaveFormularioResposta = async (data) => {
  try {
    const response = await api.post(`Formulario/resposta`, data);

    return response.data;
  } catch (error) {
    console.error("Erro ao salvar formulário resposta", error);
    throw error;
  }
};

export const UpdateFormulario = async (id, data) => {
  try {
    const response = await api.patch(`Formulario/${id}`, data);

    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar o formulário", error);
    throw error;
  }
};

export const UpdateFormularioAssociadoAoItemProcesso = async (idSolicitacaoProcessoItem, idFormularioModeloNovo) => {
  try {
    const response = await api.post(`Formulario/item/${idSolicitacaoProcessoItem}/modelo/${idFormularioModeloNovo}`);

    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar a associação do formulário ao item do processo", error);
    throw error;
  }
};

export const UpdateFormularioAssociadoAoProcesso = async (idProcesso, idFormularioModeloNovo) => {
  try {
    const response = await api.post(`Formulario/processo/${idProcesso}/modelo/${idFormularioModeloNovo}`);

    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar a associação do formulário ao processo", error);
    throw error;
  }
};

export const UpdateFormularioResposta = async (id, data) => {
  try {
    const response = await api.patch(`Formulario/resposta/${id}`, data);

    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar o formulário resposta", error);
    throw error;
  }
};

export const DeleteFormulario = async (id) => {
  try {
    await api.delete(`Formulario/${id}`);
    return true;
  } catch (error) {
    console.error('Erro ao deletar formulário:', error);
    throw error;
  }
};

export const DeleteFormularioResposta = async (id) => {
  try {
    await api.delete(`Formulario/resposta/${id}`);
    return true;
  } catch (error) {
    console.error('Erro ao deletar formulário resposta:', error);
    throw error;
  }
};

export const GetAllFormularios = async (pageSize, rowsPerPage, filters = {}) => {
  try {
    const response = await api.get('Formulario', {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
        ...filters
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar todos os formularios:', error);
    throw error;
  }
};

export const GetByIdFormulario = async (id) => {
  try {
    const response = await api.get(`Formulario/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar formulário pelo id:', error);
    throw error;
  }
};

export const GetFormularioRespostaByAssociacao = async (idSolicitacao, idFormularioAssociado) => {
  try {
    const response = await api.get(`Formulario/resposta-formulario/${idSolicitacao}/${idFormularioAssociado}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar resposta do formulário de id:', error);
    throw error;
  }
};

export const GetByIdFormularioResposta = async (id) => {
  try {
    const response = await api.get(`Formulario/resposta/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar formulário resposta pelo id:', error);
    throw error;
  }
};

// Função para buscar dados de formulários para relatórios
export const GetDataFormulariosForReports = async (pageSize, rowsPerPage, filters = {}) => {
  try {
    const response = await api.get('FormularioRelatorio', {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
        ...filters
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar dados dos formulários:', error);
    throw error;
  }
};

export default {
  SaveFormulario,
  SaveFormularioResposta,
  UpdateFormulario,
  UpdateFormularioAssociadoAoItemProcesso,
  UpdateFormularioAssociadoAoProcesso,
  UpdateFormularioResposta,
  DeleteFormulario,
  DeleteFormularioResposta,
  GetAllFormularios,
  GetByIdFormulario,
  GetFormularioRespostaByAssociacao,
  GetByIdFormularioResposta,
  GetDataFormulariosForReports
};